import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <p className="footer-text">
            © 2025 Thought Paradigm Consultancy Pvt. Ltd.
          </p>
          <p className="footer-subtext">
            Registered in India. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;